import React, { useContext, useState } from 'react';
import { AuthService } from 'core/api/services/auth';
import { getSession, setSession, removeSession } from 'core/api/session';
import { abortRefresh } from 'core/api/fetch';
import { toast } from 'react-toastify';
// import { useTranslation } from 'core/contexts/localization';

const initialUserInfo = {
    role: 'admin',
};

// const initialAuthInfo = null;

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    // const [authInfo, setAuthInfo] = useState(initialAuthInfo);
    const [userInfo, setUserInfo] = useState(initialUserInfo);
    // NB: We are hiding the become Triper/TO btn, so we no longer will set the role on localStorage
    // The logged in user will be experiencer by default
    // const [role, setUserRole] = useState('admin');
    // const { t: translate } = useTranslation();

    // useEffect(
    //     () => {
    //         getUserInfo();
    //     },
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //     []
    // );

    // const getUserInfo = () => {
    //   const authData = getSession();
    //   if (authData) {
    //     setAuthInfo(authData);
    //     AuthService.me().then((userData) => setUserInfo(userData));
    //   }
    // };

    const getUserInfoSync = async () => {
        const authData = getSession();
        if (authData) {
            const userData = await AuthService.me();
            setUserInfo(userData);
            return userData;
        }
    };

    // const login = async (data) => {
    //   try {
    //     setLoading(true);
    //     const authData = await AuthService.login({ data });

    //     if (!authData) {
    //       throw new Error();
    //     }

    //     setSession(authData);

    //     const userData = await AuthService.me();

    //     if (!userData) {
    //       throw new Error();
    //     }

    //     setAuthInfo(authData);
    //     setUserInfo(userData);

    //     setLoading(false);

    //     return true;
    //   } catch (err) {
    //     setLoading(false);
    //     toast.error(translate('landing.login.error'), {
    //       position: 'top-right',
    //       theme: 'colored',
    //     });
    //     console.error(err);
    //     return false;
    //   }
    // };

    // const signUp = async (data) => {
    //   try {
    //     setLoading(true);
    //     const signInData = await AuthService.signUp({ data });

    //     if (!signInData) {
    //       throw new Error();
    //     }

    //     setLoading(false);

    //     return true;
    //   } catch (err) {
    //     setLoading(false);
    //     toast.error(translate('landing.sign_up.error'), {
    //       position: 'top-right',
    //       theme: 'colored',
    //     });
    //     console.error(err);
    //     return false;
    //   }
    // };

    // const setRole = (role) => {
    //   localStorage.setItem(ROLE_KEY, JSON.stringify(role));
    //   setUserRole(role);
    // };

    const logout = async () => {
        try {
            setLoading(true);
            await AuthService.logout();
        } catch (error) {
            // Deliberately swallowed. If the server is down or the cookie is already gone, the user
            // must still end up logged out locally -- refusing to clear the session because the
            // network failed would strand them in a logged-in UI they cannot leave. The server side
            // is idempotent and answers 204 either way.
            console.error('@uTriper [logout]: ', error?.message);
        } finally {
            // Order matters. abortRefresh() first: a refresh may already be in flight (a 401 fired
            // just before the click), and if it resolves after removeSession() it writes a fresh
            // accessToken straight back into localStorage -- logout would appear to work only
            // intermittently. It also drops the stale Authorization default off apiClient.
            abortRefresh();
            removeSession();
            setUserInfo(initialUserInfo);
            setLoading(false);

            // Full navigation, not a react-router push: it guarantees no component keeps stale
            // authenticated state, and the auth client is a separate app anyway.
            window.location.href = `${process.env.REACT_APP_AUTH_CLIENT_URL}/?next=${process.env.REACT_APP_CLIENT ?? 'host'}`;
        }
    };

    // const googleLogin = async () => {
    //   try {
    //     setLoading(true);
    //     const authData = await AuthService.googleLogin();

    //     if (!authData) {
    //       throw new Error();
    //     }

    //     setSession(authData);

    //     const userData = await AuthService.me();

    //     if (!userData) {
    //       throw new Error();
    //     }

    //     setAuthInfo(authData);
    //     setUserInfo(userData);

    //     setLoading(false);

    //     return true;
    //   } catch (err) {
    //     setLoading(false);
    //     toast.error(translate('landing.login.error'), {
    //       position: 'top-right',
    //       theme: 'colored',
    //     });
    //     console.error(err);
    //     return false;
    //   }
    // };

    // const restoreSession = async (authData) => {
    //   try {
    //     setLoading(true);
    //     // const authData = await AuthService.restoreSession();

    //     if (!authData) {
    //       throw new Error();
    //     }

    //     setSession(authData);

    //     const userData = await AuthService.me();

    //     if (!userData) {
    //       throw new Error();
    //     }

    //     setAuthInfo(authData);
    //     setUserInfo(userData);

    //     setLoading(false);

    //     return true;
    //   } catch (err) {
    //     setLoading(false);
    //     toast.error(translate('landing.login.error'), {
    //       position: 'top-right',
    //       theme: 'colored',
    //     });
    //     console.error(err);
    //     return false;
    //   }
    // };

    const refresh = async () => {
        try {
            setLoading(true);
            const { data } = await AuthService.refresh();

            if (!data?.accessToken) {
                throw new Error('Hubo un error al Validar el Código');
            }

            setSession(data.accessToken);

            return data.accessToken;
        } catch (error) {
            toast.error(error?.message, {
                position: 'top-right',
                theme: 'colored',
            });
            console.error(error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthContext.Provider
            value={{
                loading,
                refresh,
                logout,
                // login,
                // signUp,
                // authInfo,
                userInfo,
                // role,
                // setRole,
                // getUserInfo,
                getUserInfoSync,
                // googleLogin,
                // restoreSession,
            }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

AuthProvider.displayName = 'AuthProvider';
